import { createAction, props } from '@ngrx/store';
import { getActionName } from '@app/core/state/state-helpers';

const actionPrefix = '[Dashboard]';

export const changeActiveMyWorkTab = createAction(
  getActionName('Change active my work tab', actionPrefix),
  props<{ activeMyWorkTab: string }>(),
);

export const addActivePill = createAction(
  getActionName('Add active pill', actionPrefix),
  props<{ activePill: string; inactivePills: string[] }>(),
);
export const changeActiveMyTeamTab = createAction(
  getActionName('Change active my team tab', actionPrefix),
  props<{ activeMyTeamTab: string }>(),
);
